export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif',
];

export const ALLOWED_VIDEO_TYPES = [
  'video/mp4',
  'video/quicktime',
  'video/webm',
  'video/3gpp',
];

export const MAX_IMAGE_SIZE = 3 * 1024 * 1024;
export const MAX_VIDEO_SIZE = 50 * 1024 * 1024;

export function validateMediaFiles(files, maxCount = Infinity) {
  if (files.length > maxCount) return 'count';
  for (const f of files) {
    const isImage = ALLOWED_IMAGE_TYPES.includes(f.type);
    const isVideo = ALLOWED_VIDEO_TYPES.includes(f.type);
    if (!isImage && !isVideo) return 'format';
    if (isImage && f.size > MAX_IMAGE_SIZE) return 'size';
    if (isVideo && f.size > MAX_VIDEO_SIZE) return 'size';
  }
  return null;
}

export function getMediaErrorMessage(code, t) {
  const map = {
    size: t('photoTooLarge'),
    format: t('unsupportedFormat'),
    count: t('tooManyFiles'),
  };
  return map[code] || t('uploadFailed');
}

export async function uploadMedia(file, token) {
  const data = new FormData();
  data.append('file', file);
  const res = await fetch('/api/upload', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: data,
  });
  const d = await res.json().catch(() => ({}));
  if (!res.ok || !d.url) {
    throw new Error(d.error || 'uploadFailed');
  }
  return {
    url: d.url,
    publicId: d.publicId,
    type: d.resourceType || 'image',
    thumbnailUrl: d.thumbnailUrl || d.url,
    format: d.format,
    duration: d.duration,
  };
}

// Backwards compatibility exports
export const validateImageFiles = validateMediaFiles;
export const getImageErrorMessage = getMediaErrorMessage;
export const uploadImage = uploadMedia;
